// UI Alerts
export const alertBackground = 'rgba(216, 165, 6, 0.3)';
export const alertText = '#694a04';
export const errorBackground = 'rgba(236, 88, 64, 0.1)';
export const errorText = '#ad2913';
export const noticeBackground = 'rgba(87, 140, 40, 0.1)';
export const noticeText = '#2a4a0d';
// Blues
export const lightBlue = '#a1b7d0';
export const blue = '#0f6fa8';
export const darkBlue = '#174983';
// Greens
export const green = '#478134';
// Greys
export const extraLightGrey = '#f2f2f2';
export const lightGrey = '#e1e1e1';
export const grey = '#bbbbbb';
export const darkGrey = '#707070';
export const extraDarkGrey = '#555555';
// Reds
export const red = '#ad3333';
// Yellows
export const yellow = '#edb529';
// Other
export const black = '#303030';
export const orange = '#f5a623';
export const purple = '#5e14a9';
export const white = '#ffffff';
export const offWhite = '#f5f5f5';
// Hover (match to default color)
export const extraLightGreyHover = lightGrey;
export const greyHover = '#6d6d6d';
// Border
export const greyBorder = '#c1c1c1';
// CPG Header
export const cpgHeaderGradient = 'linear-gradient(180deg, #fff 1%, #f9fafc 48%, #b4c5d9)';
//# sourceMappingURL=colors.js.map